import { render, staticRenderFns } from "./Camas.vue?vue&type=template&id=188de375"
import script from "./Camas.vue?vue&type=script&lang=js"
export * from "./Camas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports